import React from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./FeedbackModal.css";

const FeedbackModal = ({ open, onClose, variant = "success", title, message }) => {
  const isSuccess = variant === "success";

  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      classNames={{
        overlay: "feedback-modal-overlay",
        modal: `feedback-modal feedback-modal--${isSuccess ? "success" : "error"}`,
        closeButton: "feedback-modal-close",
      }}
      aria-labelledby="feedback-modal-title"
      aria-describedby="feedback-modal-message"
    >
      <div className="feedback-modal-content">
        <div className="feedback-modal-icon" aria-hidden="true">
          {isSuccess ? (
            <svg viewBox="0 0 24 24">
              <path d="m5 12 4.25 4.25L19 6.5" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24">
              <path d="M12 7v6M12 17h.01" />
            </svg>
          )}
        </div>
        <p className="feedback-modal-label">
          {isSuccess ? "Success" : "Something went wrong"}
        </p>
        <h2 id="feedback-modal-title">{title}</h2>
        <p id="feedback-modal-message" className="feedback-modal-message">
          {message}
        </p>
        <button type="button" className="feedback-modal-action" onClick={onClose}>
          {isSuccess ? "Done" : "Try again"}
        </button>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
